import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { chunk, first, flatten, includes, last, range } from 'lodash'

class Pagination extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lastPageNumber: this.props.lastPageNumber || 1,
      currentPageNumber: this.props.currentPageNumber || 1,
      pageNumberPerPage: this.props.pageNumberPerPage || 4,
      onClick: this.props.onClick,
    };

    this.click = this.click.bind(this);
  }

  createPageSets() {
    return (
      chunk(range(1, this.state.lastPageNumber + 1), this.state.pageNumberPerPage)
    )
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      currentPageNumber: nextProps.currentPageNumber,
      lastPageNumber: nextProps.lastPageNumber,
    })
  }

  getCurrentPageSet(pageSets) {
    return (
      flatten(
        pageSets.filter(
          (pageSet) => (
            includes(pageSet, this.state.currentPageNumber)
          )
        )
      )
    )
  }

  noPages() {
    return (this.state.lastPageNumber === 1 || this.state.lastPageNumber < this.state.currentPageNumber)
  }

  click(e, pageNumber, currentPageSet) {
    if (this.shouldDisablePreviousLink(pageNumber, currentPageSet)) {
      e.preventDefault();
    } else if (this.shouldDisableNextLink(pageNumber, currentPageSet)) {
      e.preventDefault();
    } else if (pageNumber === this.state.currentPageNumber) {
      e.preventDefault();
    } else {
      return this.state.onClick(pageNumber);
    }
  }

  shouldDisablePreviousLink(pageNumber, currentPageSet) {
    return ((first(currentPageSet) === 1) && (pageNumber === 0));
  }

  shouldDisableNextLink(pageNumber, currentPageSet) {
    return (last(currentPageSet) === this.state.lastPageNumber && pageNumber === this.state.lastPageNumber + 1);
  }

  shouldDisableCurrentPageLink(pageNumber) {
    return pageNumber === this.state.currentPageNumber
  }

  renderDisableLinkClass(pageNumber, currentPageSet) {
    if (this.shouldDisablePreviousLink(pageNumber, currentPageSet) ||
      this.shouldDisableNextLink(pageNumber, currentPageSet) ||
      this.shouldDisableCurrentPageLink(pageNumber)) {
      return "pagination-rounded__link--disable";
    }
  }

  render() {
    if (this.noPages()) {
      return null;
    }

    const pageSets = this.createPageSets();
    const pageSet = this.getCurrentPageSet(pageSets);

    return (
      <ul className="pagination-rounded">
        <li>
          <a
            className={`
              pagination-rounded__link
              pagination-rounded__link--side
              ${this.renderDisableLinkClass(parseInt(first(pageSet)) - 1, pageSet)}
            `}
            onClick={(e) => (this.click(e, parseInt(first(pageSet)) - 1, pageSet))}
          >
            <i className="fa fa-chevron-left"></i>
          </a>
        </li>

        {pageSet.map((page, index) => (<li key={index}>
          <a
            className={`
              pagination-rounded__link
              ${this.state.currentPageNumber == page ? "pagination-rounded__link--active" : ""}
              ${this.renderDisableLinkClass(page)}
            `}
            onClick={(e) => (this.click(e, page, pageSet))}
          >
            {page}
          </a>
        </li>
        ))}

        <li>
          <a
            className={`
              pagination-rounded__link
              pagination-rounded__link--side
              ${this.renderDisableLinkClass(parseInt(last(pageSet)) + 1, pageSet)}
            `}
            onClick={(e) => (this.click(e, parseInt(last(pageSet)) + 1, pageSet))}
          >
            <i className="fa fa-chevron-right"></i>
          </a>
        </li>
      </ul>
    )
  }
}

Pagination.propTypes = {
  lastPageNumber: PropTypes.number,
  currentPageNumber: PropTypes.number,
  pageNumberPerPage: PropTypes.number,
  onClick: PropTypes.func,
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/Common/Pagination.js